/** KWD has 3 decimals (fils): 10 -> "KD 10.000". */
export const formatKd = (amount) =>
    Number(amount || 0)
        .toLocaleString('en-US', { style: 'currency', currency: 'KWD', minimumFractionDigits: 3, maximumFractionDigits: 3 })
        .replace('KWD', 'KD');

/** Rounds to the fils (3 decimals). */
export const roundFils = (value) => Math.round((Number(value) || 0) * 1000) / 1000;
